"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALUE = exports.RANGE = exports.STRING = exports.NUMBER = void 0;
var NUMBER = 'number';
exports.NUMBER = NUMBER;
var STRING = 'string';
exports.STRING = STRING;
var RANGE = 'range';
exports.RANGE = RANGE;
var VALUE = 'value';
exports.VALUE = VALUE;